import { useTranslation } from 'react-i18next'
import { resolveIncident } from 'service/DormService'

import styles from './IncidentsTab.module.scss'

const IncidentsTab = ({ incidents, reload }) => {
  const { t } = useTranslation('common')

  return (
    <table className={styles.table}>
      <thead>
        <tr>
          <th>{t('dorm.col_date')}</th>
          <th>{t('dorm.col_student_room')}</th>
          <th>{t('dorm.col_kind')}</th>
          <th>{t('dorm.col_description')}</th>
          <th>{t('dorm.col_status')}</th>
          <th></th>
        </tr>
      </thead>
      <tbody>
        {incidents.map((i) => (
          <tr key={i.id}>
            <td>{(i.reported_at || '').slice(0, 10)}</td>
            <td>{i.student || (i.room ? t('dorm.room_label', { num: i.room }) : '—')}</td>
            <td>{i.kind_display}</td>
            <td>{i.description?.slice(0, 80)}</td>
            <td>{i.status_display}</td>
            <td>
              {i.status === 'new' && (
                <button
                  className={styles.smallBtn}
                  onClick={async () => {
                    const res = prompt(t('dorm.resolution_prompt'))
                    if (!res) return
                    await resolveIncident(i.id, { resolution: res })
                    reload()
                  }}
                >
                  {t('dorm.resolve_btn')}
                </button>
              )}
            </td>
          </tr>
        ))}
      </tbody>
    </table>
  )
}

export default IncidentsTab
